const semanticClassNames = {
  root: 'text-box',
  label: 'text-box__label',
  input: 'text-box__input',
} as const;

export default semanticClassNames;
